import axios from "axios";
import { toastr } from "react-redux-toastr";
import { reset as resetForm, initialize } from "redux-form";
import { showTabs, selectTab } from "../common/tab/tabActions";
import util from '../consts'
const BASE_URL = util.API_URL;

const INITIAL_VALUES = {

}


export function getList(tipo="",valor="", offset=0, limit=15) {
    const request = axios.get(`${BASE_URL}/usuarios`,{
        headers: {
            tipo,
            valor,
            offset, 
            limit
        }
    })
    return {
        type: 'USUARIO_FETCHED',
        payload: request
    }
}

/*export function pesquisar(tipo,valor) {

    const request = axios.get(`${BASE_URL}/usuarios`, {
        headers: {
            tipo: tipo,
            valor: valor
        }
    })
    return {
        type: 'USUARIO_FETCHED',
        payload: request
    }
}*/

export function create(values) {
    return submit(values, 'post')
}

export function update(values) {
    return submit(values, 'put')
}

export function remove(values) {
    values.data_exclusao = new Date();
    values.excluido = true;
    return submit(values, 'put')
}

function submit(values, method) {
    return dispatch => {
        axios[method](`${BASE_URL}/usuarios`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(init())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function showUpdate(usuario) {

    return [
        showTabs('tabUpdate'),
        selectTab('tabUpdate'),
        initialize('usuarioForm', usuario)
    ]
}

/* TODO refatorar para utilizar um metodo so com o showupdate*/
export function showDelete(usuario) {
    return [
        showTabs('tabDelete'),
        selectTab('tabDelete'),
        initialize('usuarioForm', usuario)
    ]
}

export function init() {
    return [
        showTabs('tabList', 'tabCreate'),
        selectTab('tabList'),
        getList(),
        initialize('usuarioForm', INITIAL_VALUES)
    ]
}


// WEBPACK FOOTER //
// ./src/usuario/usuarioAction.js